import {
  Component,
  DestroyRef,
  inject,
} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';
import {Store} from '@ngrx/store';
import {TranslatePipe} from '@ngx-translate/core';
import {firstValueFrom} from 'rxjs';
import {AppState} from '../../store/store';
import {selectIsPreviewMode} from '../../store/shared-link/shared-link.selectors';
import {PreviewModeService} from '../../services/preview-mode/preview-mode.service';

@Component({
  selector: 'app-back-button',
  imports: [MatButtonModule, TranslatePipe],
  templateUrl: './back-button.component.html',
  styleUrl: './back-button.component.scss',
})
export class BackButtonComponent {

  private store: Store<AppState> = inject(Store<AppState>);

  private router: Router = inject(Router);

  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  private previewModeService: PreviewModeService = inject(PreviewModeService);

  private destroyRef: DestroyRef = inject(DestroyRef);

  public previewMode$ = this.store.select(selectIsPreviewMode);

  async handleNavigateOneLevelBack(): Promise<void> {
    const previewMode = await firstValueFrom(this.previewMode$);
    if (this.destroyRef.destroyed) {
      return;
    }
    if (previewMode) {
      await this.previewModeService.toPreview();
    } else {
      const username = (this.activatedRoute?.firstChild || this.activatedRoute)?.snapshot.paramMap.get('username');
      if (username) {
        await this.router.navigate(['/', username]);
      }
    }
  }

}
